import React from 'react';

function renderImageBlock(data, index) {
  const {
          ALT,
          BACKGROUND_COLOR,
          CONTENT = [],
        } = data;

  const [img] = CONTENT;

  return (
    <section key={index} style={{ backgroundColor: BACKGROUND_COLOR }}>
      <div className={'container'}>
        <picture>
          {(img?.endsWith('.svg') || img?.endsWith('.gif')) ? (
            <img
              src={`${img}?t=${BUILD_TIME}`}
              alt={ALT}
            />
          ) : (
            <>
              <source
                srcSet={`${img}.webp?w=768&default=vertical&t=${BUILD_TIME}`}
                media={'(max-width: 767px)'}
                type="image/webp"
              />
              <source
                srcSet={`${img}.png?w=768&default=vertical&t=${BUILD_TIME}`}
                media={'(max-width: 767px)'}
                type="image/png"
              />
              <source
                srcSet={`${img}.webp?w=992&default=vertical&t=${BUILD_TIME}`}
                media={'(min-width: 768px) && (max-width: 992px)'}
                type="image/webp"
              />
              <source
                srcSet={`${img}.png?w=992&default=vertical&t=${BUILD_TIME}`}
                media={'(min-width: 768px) && (max-width: 992px)'}
                type="image/png"
              />
              <source
                srcSet={`${img}.webp?w=1152&default=vertical&t=${BUILD_TIME}`}
                media={'(min-width: 992px)'}
                type="image/webp"
              />
              <source
                srcSet={`${img}.png?w=1152&default=vertical&t=${BUILD_TIME}`}
                media={'(min-width: 992px)'}
                type="image/png"
              />
              <img
                src={`${img}.png?w=1152&default=horizontal&t=${BUILD_TIME}`}
                srcSet={`
                    ${img}.png?w=768px&default=horizontal&t=${BUILD_TIME} 320w
                    ${img}.png?w=992px&default=horizontal&t=${BUILD_TIME} 992w
                    ${img}.png?w=1152px&default=horizontal&t=${BUILD_TIME} 1152w
                  `}
                sizes={`
                    (max-width: 767px) 320px,
                    (min-width: 768px) 992px,
                    1152px
                  `}
                alt={ALT}
              />
            </>
          )}
        </picture>
      </div>
    </section>
  );
}

export default renderImageBlock;